
            const data = {"name":"ic_right","data":{"width":"6","height":"9","viewBox":"0 0 6 9","data":"<path pid=\"0\" d=\"M1 8l3.5-3.75L1 1\" _stroke=\"#5B5B5B\" stroke-width=\".875\" stroke-linecap=\"round\"/>","originalColors":[{"type":"stroke","color":"#5B5B5B"}],"stopColors":[]}}
        
                module.exports = data
                